import React, { useState, useEffect, useContext } from "react";
import config from "../appconfig/config.json";
import ReCAPTCHA from "react-google-recaptcha";  //commented 
import { useHistory } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
// import '../styles/card-style.css';
import { Checkbox } from "@progress/kendo-react-inputs";
import service from '../services/ApiService.js';
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import helper from '../factory/Helper';
import { CusFormInput3 } from "../validation/Form-Components";
import CusToast from '../components/CusToast';
import { CardImage } from '@progress/kendo-react-layout';
import resumeperson from '../images/sme-banner1.png';
import { nricValidator, uenValidator } from "../validation/Validators";
import storage from '../factory/StorageFactory';
import OTPbar from "../components/OTPbar";
import Loading from "../components/Loading";

let verifyFormResData = {};

const ResumeApplication = (props) => {

  const appStatusCancel = 'CANCELLED', appStatusExpired = 'EXPIRED', appStatusSubmitted = 'SUBMITTED', appStatusNoRecord = 'NO RECORD',appStatusRejected = 'REJECTED';
  const typeStatus = 'Status', typeResume = 'Resume';
  let timer;

  const history = useHistory();
  const [currentTime, setCurrentTime] = useState();

  const [showOTPBar, setShowOTPBar] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [dataParams, setDataParams] = useState();
  const [captchaResult, setCaptchaResult] = useState(false); //Google recaptcha value

  useEffect(() => {
    console.log('@financeDetails useEffect')
    // window.localStorage.clear();
    // window.sessionStorage.clear();
    storage.clearAll();
    postSecurity();

    return () => {
      setIsVerifying(false);
      clearTimeout(timer);
    }
  }, []);


  const postSecurity = () => {
    service.security().then(res => {
      let resData = res.data;
      if (resData) {
        storage.setToken(resData.token);
        storage.setTokenExpiry(resData.tokenExpirationDate);
        storage.setIsAPSavedForm(false);
      }
    })
    .catch(err => {
      showErrMsg('Service is not available.');
    });
  }

  function onChangeRecapthcha(value) {

    let cValue = value;
    if(cValue) {
      setCaptchaResult(true);
    }
    else {
     setCaptchaResult(false);
    }
  }

  const onRecaptchaErrored = (e) => {
    console.log('@onRecaptchaErrored')
    showErrMsg(config.error.ReCaptchaFailed);
  }

  const onAsyncScriptOnLoad = () => {
    console.log('@onAsyncScriptOnLoad')
  }

  const onRecaptchaExpired = () => {
    console.log('@onRecaptchaExpired');
    setCaptchaResult(false);
  }

  const [statusenquiryValue, setstatusenquiryValue] = useState(true);
  const [resumeAppValue, setresumeAppValue] = useState(false);

  const [isError, setIsError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [initFormData, setInitFormData] = useState({
    UENumber: "",
    NRICorFIN: ""
  });

  const handleResumeapp = () => {
    setstatusenquiryValue(false);
    setresumeAppValue(true);
  }

  const handleStatusenqry = () => {
    setstatusenquiryValue(true);
    setresumeAppValue(false);
  }

  const showErrMsg = (msg) => {
    setIsError(true);
    setErrMsg(msg);
    setErrMsgTimeout();
  }

  const setErrMsgTimeout = () => {
    timer = setTimeout(() => {
      setIsError(false);
    }, config.error.msgTimeout);
  }

  const getOTPCurrentTime = () => {
    let cTime = helper.getCurrentTime();
    setCurrentTime(cTime);
    setTimeout(getOTPCurrentTime, 1000);
  }

  const handleSubmit = (dataItem) => {
    if(config.ReCaptcha.enable && !captchaResult) {
      showErrMsg("Please do not leave field blank.");
      return;
    }
    if (!statusenquiryValue && !resumeAppValue) {
      showErrMsg("Select Status Enquiry / View Offer or Resume Application Option.");
      return;
    }

    let typeValue = '';
    if (statusenquiryValue) {
      typeValue = 'Status';
    }
    else if (resumeAppValue) {
      typeValue = 'Resume';
    }

    if (dataItem.isValid) {
      let data = JSON.parse(JSON.stringify(dataItem.values));

      let params = {
        type: typeValue,
        uen: data.UENumber,
        nric: data.NRICorFIN
      }

      saveVerificationForm(params)
    }
  }

  const saveVerificationForm = (params) => {
    setIsVerifying(true);
    service.verificationForm(params).then(res => {
      setIsVerifying(false);
      let resData = res.data.model;
      if (res.data.isSucess) {
        if (resData.referenceNo === "" || resData.referenceNo === null || resData.referenceNo === undefined) {
          if(resData.status.toUpperCase() === appStatusNoRecord) {
            showErrMsg('We are sorry. There are no records found.');
            return;
          }
          
          showErrMsg('We are sorry. There are no records found.');
        }
        else {
          if (resData.status === "" || resData.status === null || resData.status.toUpperCase() === appStatusSubmitted) {
            //success
            if (resData.isFirstUser === null || resData.isContinue === null) { //check isFirstUser and isContinue Value
              history.push(config.route.InvalidApplication)
              return;
            }

            if (resData.moblileNo === null || resData.moblileNo === "") {
              showErrMsg('We are sorry. There are no records found.')
              return;
            }

            if (params.type === typeResume && resData.status.toUpperCase() === appStatusSubmitted) {
              showErrMsg('We are sorry. There are no records found.')
              return;
            }
 
            if (params.type === typeStatus && resData.stateid.length === 0) {
              showErrMsg('We are sorry. There are no records to status enquiry / view offer.')
              return;
            }

            verifyFormResData = resData;
            storage.setRefNo(resData.referenceNo);
            if (resData.product !== null) {
              //V2 check
              if(resData.product === config.bizFinancing.BTL) { //Online existing
                storage.setIsFProdBTL('t');
              }
              else { 
                storage.setIsFProdBTL('f');
              }

              //V1 
              if (resData.isFirstUser === 'true' && resData.product === 'WCL') {
                storage.setIsProductWCL(true);
              }
              else {
                storage.setIsProductWCL(false);
              }
            }

            setDataParams({
              nric: params.nric,
              uen: params.uen,
              type: params.type
            })

            if (config.EnableOTPbar) {
              getOTPCurrentTime();
              setShowOTPBar(true);
            }
            else {
              setShowOTPBar(false);
              goNext(resData.stateid, resData.name, resData.isFirstUser, resData.isContinue, params.nric, params.uen, params.type,resData.isAuthorisedPerson);
            }
          }
          else {
            displayErrMsgByStatus(resData.status,params.type);
          }
        }
      }
      else {
        showErrMsg(config.error.SaveApiFailed);
      }
    })
      .catch(err => {
        setIsVerifying(false);
        showErrMsg(config.error.SaveApiFailed);
      });
  }

  const goNext = (sid, name, isFirstUser, isContinue, ic, uen, type, isGreenAP) => {
    storage.setAppStage(config.AppStage.APPRESUME);
    storage.setShowNonLending(false);
    storage.setIsFirstTime(isFirstUser);
    storage.setIsGreenAP(isGreenAP);
    if (type === typeResume) {
      history.push(config.route.Welcome, { from: config.route.ResumeApplication, sid: sid, n: name, isFU: isFirstUser, isCont: isContinue, ic: ic, uen: uen, type: type });  
    }
    else {
      history.push(config.route.StatusDetails, { from: config.route.ResumeApplication, uen: uen, idNum: ic, sid: sid, refNo: storage.getRefNo()});
    }
  }

  const displayErrMsgByStatus = (resDataStatus,type) => {

    if (resDataStatus === null || resDataStatus === "") {
      showErrMsg('We are sorry. There are no records found.')
      return;
    }

    if (resDataStatus.toUpperCase() === appStatusNoRecord) {
      if(type === typeStatus) {
        showErrMsg('We are sorry. There are no records found.')
      }
      else {
        showErrMsg('We are sorry. There are no records to resume application.');
      }
      return;
    }

    if(resDataStatus.toUpperCase() === appStatusRejected) {
      if (type === typeStatus) {  
        showErrMsg('We are sorry. There are no records found.');
      }
      else {
        showErrMsg('We are sorry. There are no records to resume application.');
      }
      return;
    }

    if (resDataStatus.toUpperCase() === appStatusCancel) {
      showErrMsg('The financing application has been cancelled.\nPlease reapply.')
      return;
    }

    if (resDataStatus.toUpperCase() === appStatusExpired) {
      history.push(config.route.InvalidApplication)
      return;
    }
  }

  const onOTPSubmitSuccess = () => {
    //OTP Submitted Sucessfully, do Next upon fsd.
    // console.log('onOTPSubmitSuccess Yayy');
    goNext(verifyFormResData.stateid, verifyFormResData.name, verifyFormResData.isFirstUser, verifyFormResData.isContinue, dataParams.nric, dataParams.uen, dataParams.type,verifyFormResData.isAuthorisedPerson);
  }


  return (
    <div className="container-fluid">
      <br></br>
      <p className="welcome mb-0 k-align-items-center">
       {config.Branding.title}
      </p>
      <div className="demo-section k-content dynmicwhitecntr DynamicFields">
        <div className="cardbd">
          <CardImage className="hdImg" alt="bImag1" src={resumeperson} />
          <div>
            <p className="welcomeblack mb-0 k-align-items-center">
              {'Welcome back!'}
            </p>
            <p style={{
              textAlign: "center",
              fontWeight: "500",
              letterSpacing: 0,
              color: "#585858",
              opacity: "1",
              fontSize: "1em"
            }} className="k-align-items-center">
              {'Resume or check your application status'}
            </p>
            <Form
              onSubmitClick={handleSubmit}
              initialValues={initFormData}
              key={JSON.stringify(initFormData)}
              render={(formRenderProps) => (
                <FormElement>
                  <br /> <br />
                  <fieldset>
                    <div className="row around-xs inputPair elementVisible">
                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{ fontWeight: "600" }}>What would you like to do?</div>
                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <Checkbox
                          id={"StatusEnquiry"}
                          name={"StatusEnquiry"}
                          key={"StatusEnquiry"}
                          disabled={showOTPBar}
                          checked={statusenquiryValue}
                          onClick={handleStatusenqry}
                          onChange={(e) => {
                          }}
                          label={
                            <b style={{ marginLeft: "10px", fontWeight: "500" }}>
                              {
                                "Status Enquiry / View Offer"
                              }
                              { }
                            </b>
                          }
                        /></div>
                    </div>

                    <div className="row around-xs inputPair elementVisible">
                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6"></div>
                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <Checkbox
                          // defaultChecked={false}
                          id={"ResumeApp"}
                          name={"ResumeApp"}
                          key={"ResumeApp"}
                          disabled={showOTPBar}
                          checked={resumeAppValue}
                          onClick={handleResumeapp}
                          onChange={(e) => {
                          }}
                          label={
                            <b style={{ marginLeft: "10px", fontWeight: "500" }}>
                              {"Resume Application "}
                            </b>
                          } />
                      </div>
                    </div>
                    <br></br>
                    <Field
                      component={CusFormInput3}
                      leftLabelId={"UENumber"}
                      leftLabelName={"Your Business Unique Entity Number (UEN)"}
                      id={"UENumber"}
                      name={'UENumber'}
                      disabled={showOTPBar}
                      placeholder={"eg. 1234567890M"}
                      validator={uenValidator} />

                    <Field
                      component={CusFormInput3}
                      leftLabelId={"NRICorFIN"}
                      leftLabelName={"Your NRIC/FIN"}
                      id={"NRICorFIN"}
                      name={'NRICorFIN'}
                      disabled={showOTPBar}
                      placeholder={"eg. S9123456M"}
                      validator={nricValidator} />

                    {config.ReCaptcha.enable && 
                    <div className="row around-xs inputPair elementVisible">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="k-align-items-center">
                        <div className="recaptcha-box">
                        <ReCAPTCHA
                            className="g-recaptcha"
                            sitekey={config.ReCaptcha.sitekey}
                            onChange={onChangeRecapthcha}
                            onErrored={onRecaptchaErrored}
                            asyncScriptOnLoad={onAsyncScriptOnLoad}
                            onExpired={onRecaptchaExpired} /> 
                        </div>
                      </div>
                    </div>
                    </div>
                    }
                    
                    <div style={{ marginTop: "1rem" }} className="row around-xs inputPair elementVisible">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }} >
                        <div style={{ textAlign: "center", fontWeight: "200" }} className="  k-align-items-center">
                          <Button
                            style={{ width: '22%', padding: '5px', fontSize: '1em', color: '#FFFFFF' }}
                            type={"submit"}
                            onClick={handleSubmit}
                            disabled={(!formRenderProps.valid||showOTPBar)}
                            className="k-button-maybank" >
                            {"Submit"}
                          </Button><br></br>
                        </div>
                      </div>
                    </div>

                  </fieldset>
                </FormElement>
              )}
            ></Form>
          </div>
        </div>
      </div>
      {showOTPBar &&
        <FieldWrapper>
          <br /><br /><br /><br /><br />
          <OTPbar id={'1OtP'} userMobileNo={verifyFormResData.moblileNo} currentTime={currentTime} otpTimer={timer} history={history} handleOTPSubmitSuccess={() => { onOTPSubmitSuccess() }} />
        </FieldWrapper>
      }
      <br />
      <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  />
      {isVerifying && <Loading />}
    </div>
  );
};

export default ResumeApplication;
